export enum CustomBrandingCdnResource {
    LOGO = "logo",
    WALLPAPER = "wallpaper",
    FAVICON = "favicon",
}
